import Vue from "vue";
import Router from "vue-router";
import i18n from "@/i18n";

Vue.use(Router);
const router = new Router({
  routes: [
    // DASHBOARD
    {
      path: "/",
      name: "mainActivity",
      redirect: "/dashboard",
      meta: { main_page: true },
      component: () => import("./core/plugins/TitleRibbon/index"),
      children: [
        {
          path: "/dashboard",
          component: () => import("@/view/layout/Home.vue"),
          name: "home",
          meta: { title: "router.dashboard", main_page: true },
        },
        {
          path: "/phonebook",
          name: "contacts",
          component: () => import("@/view/pages/contacts/index.vue"),
          meta: {
            title: "router.contacts",
            has_ribbon: true,
            permission: "phoneBook_access",
          },
          children: [
            {
              path: "edit/:slug",
              name: "edit.phonebook",
              component: () =>
                import("@/view/pages/contacts/view/editContact.vue"),
              meta: {
                title: "router.editContact",
                permission: "phoneBook_access",
                has_ribbon: true,
              },
              props: true,
            },
            {
              path: "create",
              name: "create.phonebook",
              component: () =>
                import("@/view/pages/contacts/view/newContact.vue"),
              meta: {
                title: "router.createContact",
                permission: "phoneBook_access",
                has_ribbon: true,
              },
              props: true,
            },
          ],
        },
        {
          path: "customers",
          name: "customers",
          component: () => import("@/view/pages/customers/index.vue"),
          meta: { title: "router.customers", has_ribbon: true },
        },
        {
          path: "/contact/list",
          name: "get.contacts",
          component: () => import("@/view/pages/contacts/list/contactList.vue"),
          meta: { title: "router.contactList", has_ribbon: true },
        },
        {
          path: "/admin/messages",
          name: "messages.index",
          component: () => import("@/view/pages/admin/Messages/Index.vue"),
          meta: {
            title: "router.messages",
            permission: "messages_page",
            has_ribbon: true,
          },
        },
        {
          path: "/admin/message-categories",
          name: "messages.categories.index",
          component: () =>
            import("@/view/pages/admin/Messages/MessageCategory/Index.vue"),
          meta: {
            title: "router.messageCategories",
            permission: "message_categories_index",
            has_ribbon: true,
          },
        },
        {
          path: "/table",
          name: "table",
          component: () => import("@/view/pages/table/table-sample.vue"),
        },
        {
          path: "/transaction",
          name: "increaseTransactions",
          component: () =>
            import("@/view/pages/transactions/increaseTransactions.vue"),
        },
        {
          path: "/user/old-transactions",
          name: "user.old.transactions",
          component: () =>
            import("@/view/pages/transactions/UserTransactions.vue"),
          meta: { title: "router.oldTransactions", has_ribbon: true },
        },
        {
          path: "/user/transactions",
          name: "user.transactions",
          component: () =>
            import(
              "@/view/pages/transactions/newWallet/newUserTransactions.vue"
            ),
          meta: { title: "router.yourTransactions", has_ribbon: true },
        },
        {
          path: "/panel",
          name: "buyPanel",
          component: () => import("@/view/pages/transactions/buyPanel.vue"),
          meta: { title: "router.buyPanel", has_ribbon: true },
        },
        {
          path: "permission",
          name: "permission.index",
          component: () => import("@/view/pages/permission/Index.vue"),
          meta: {
            title: "router.permissions",
            permission: "",
            has_ribbon: true,
          },
        },
        {
          path: "permission/create",
          name: "permission.create",
          component: () => import("@/view/pages/permission/Create.vue"),
          meta: {
            title: "router.createPermission",
            permission: "permission_create",
            has_ribbon: true,
          },
        },
        {
          path: "permission/:id/edit",
          name: "permission.edit",
          component: () => import("@/view/pages/permission/Edit.vue"),
          meta: { title: "router.permissionTitle", has_ribbon: true },
        },
        {
          path: "/myInvention",
          name: "user.inventions",
          component: () => import("@/view/pages/invitation/Index.vue"),
          meta: { title: "router.invitations", has_ribbon: true },
          props: true,
        },
        {
          path: "/admin/user/:id",
          name: "admin.user.edit",
          component: () => import("@/view/pages/admin/users/actions/Edit.vue"),
          meta: {
            title: "router.editUser",
            permission: "user_edit",
            has_ribbon: true,
          },
          props: true,
        },
        {
          path: "/admin/user-info/:id",
          name: "admin.users.information",
          component: () =>
            import("@/view/pages/admin/users/actions/Information.vue"),
          meta: {
            title: "router.userInformation",
            permission: "user_show",
            has_ribbon: true,
          },
          props: true,
        },
        {
          path: "/admin/walletEdit/:id",
          name: "admin.users.wallet",
          component: () =>
            import("@/view/pages/admin/users/actions/walletEdit.vue"),
          meta: {
            title: "router.walletEdit",
            permission: "user_show",
            has_ribbon: true,
          },
          props: true,
        },
        {
          path: "/admin/history/:phone",
          name: "admin.users.history",
          component: () =>
            import("@/view/pages/admin/users/actions/UserHistory.vue"),
          meta: {
            title: "router.userHistory",
            permission: "adminUsersbtn_history",
            has_ribbon: true,
          },
          props: true,
        },
        {
          path: "/admin/user-history/notifications",
          name: "admin.users.history.notification",
          component: () =>
            import("@/view/pages/admin/users/actions/UserNotification.vue"),
          meta: {
            title: "router.userNotificationsHistory",
            permission: "userNotifHistory_show",
            has_ribbon: true,
          },
        },
        {
          path: "/notifications",
          name: "notifications.index",
          component: () => import("@/view/pages/admin/notifications/Index.vue"),
          meta: {
            title: "router.notifications",
            permission: "notification_access",
            has_ribbon: true,
          },
        },
        {
          path: "/notification/create",
          name: "notification.create",
          component: () =>
            import("@/view/pages/admin/notifications/Create.vue"),
          meta: {
            title: "router.createNotification",
            permission: "notification_create",
            has_ribbon: true,
          },
        },
        {
          path: "/notification/:id",
          name: "notification.edit",
          component: () => import("@/view/pages/admin/notifications/Edit.vue"),
          meta: {
            title: "router.editNotification",
            permission: "notification_edit",
            has_ribbon: true,
          },
          props: true,
        },
        {
          path: "/adminNotifications",
          name: "adminNotifications.index",
          component: () =>
            import("@/view/pages/admin/adminNotifications/Index.vue"),
          meta: {
            title: "router.adminNotifications",
            permission: "notification_access",
            has_ribbon: true,
          },
        },
        {
          path: "/adminNotifications/:id",
          name: "adminNotifications.edit",
          component: () => import("@/view/pages/admin/notifications/Edit.vue"),
          meta: {
            title: "router.editNotification",
            permission: "notification_edit",
          },
          props: true,
        },
        {
          path: "/user/notifications",
          name: "userNotification.index",
          component: () =>
            import("@/view/pages/admin/notifications/UserNotification.vue"),
          meta: { title: "router.yourNotifications", has_ribbon: true },
        },
        {
          path: "admin/notifications",
          name: "admin.notifications.index",
          component: () =>
            import("@/view/pages/admin/notifications/AdminNotifications.vue"),
          meta: {
            title: "router.adminNotificationsList",
            has_ribbon: true,
            permission: "admin_notifications",
          },
        },
        {
          path: "/tickets",
          name: "tickets.index",
          component: () => import("@/view/pages/tickets/Index.vue"),
          meta: { title: "router.tickets", has_ribbon: true },
        },
        {
          path: "/tickets/create",
          name: "tickets.create",
          component: () => import("@/view/pages/tickets/Create.vue"),
          meta: { title: "router.createTicket", has_ribbon: true },
        },
        {
          path: "/tickets/:id",
          name: "tickets.edit",
          component: () => import("@/view/pages/tickets/Edit.vue"),
          props: true,
          meta: { title: "router.editTicket", has_ribbon: true },
        },
        {
          path: "/departments",
          name: "departments.index",
          component: () => import("@/view/pages/admin/departments/Index.vue"),
          meta: { title: "router.departments", has_ribbon: true },
        },
        {
          path: "/departments/create",
          name: "departments.create",
          component: () => import("@/view/pages/admin/departments/Create.vue"),
          meta: { title: "router.createDepartment", has_ribbon: true },
        },
        {
          path: "/departments/:id",
          name: "departments.edit",
          component: () => import("@/view/pages/admin/departments/Edit.vue"),
          props: true,
          meta: { title: "router.editDepartment", has_ribbon: true },
        },
        {
          path: "/adminTickets",
          name: "adminTickets.index",
          component: () => import("@/view/pages/admin/adminTickets/Index.vue"),
          meta: { title: "router.adminTickets", has_ribbon: true },
        },
        {
          path: "/adminTickets/:id",
          name: "adminTickets.edit",
          component: () => import("@/view/pages/admin/adminTickets/Edit.vue"),
          props: true,
          meta: { title: "router.editTicket", has_ribbon: true },
        },
        {
          path: "/adminDiscounts",
          name: "adminDiscounts.index",
          component: () =>
            import("@/view/pages/admin/adminDiscounts/Index.vue"),
          meta: {
            title: "router.discounts",
            permission: "notification_access",
            has_ribbon: true,
          },
        },
        {
          path: "/adminDiscounts/create",
          name: "adminDiscounts.create",
          component: () =>
            import("@/view/pages/admin/adminDiscounts/Create.vue"),
          meta: {
            title: "router.createDiscount",
            permission: "notification_create",
            has_ribbon: true,
          },
        },
        {
          path: "/adminDiscounts/:id",
          name: "adminDiscounts.edit",
          component: () => import("@/view/pages/admin/adminDiscounts/Edit.vue"),
          meta: {
            title: "router.editDiscount",
            permission: "notification_edit",
            has_ribbon: true,
          },
          props: true,
        },
        {
          path: "/workReports",
          name: "workReports.index",
          component: () => import("@/view/pages/workReports/Index.vue"),
          meta: {
            title: "router.workReports",
            permission: "workReports_access",
            has_ribbon: true,
          },
        },
        {
          path: "/workReports/create",
          name: "workReports.create",
          component: () => import("@/view/pages/workReports/Create.vue"),
          meta: {
            title: "router.createWorkReport",
            permission: "workReports_create",
            has_ribbon: true,
          },
        },
        {
          path: "/admin/cdr",
          name: "admin.cdr.index",
          component: () => import("@/view/pages/admin/cdr/Index.vue"),
          meta: { title: "router.callMonitoring", has_ribbon: true },
        },
        {
          path: "/admin/workReports",
          name: "admin.workReports.index",
          component: () => import("@/view/pages/admin/workReports/Index.vue"),
          meta: {
            title: "router.adminWorkReports",
            permission: "AdminworkReports_access",
            has_ribbon: true,
          },
        },
        {
          path: "/admin/workReports/edit/:id",
          name: "admin.workReports.edit",
          component: () => import("@/view/pages/admin/workReports/Edit.vue"),
          meta: {
            title: "router.editWorkReport",
            permission: "AdminworkReports_edit",
            has_ribbon: true,
          },
          props: true,
        },
        {
          path: "/payment-callback",
          name: "paymentCallback",
          component: () =>
            import("@/view/pages/payment-callback/PaymentStatus.vue"),
        },
        {
          path: "/payment-callback-new",
          name: "paymentCallbackNew",
          component: () =>
            import("@/view/pages/payment-callback-new/PaymentStatus.vue"),
        },
        {
          path: "/pack-properties",
          name: "pack-properties.index",
          component: () =>
            import("@/view/pages/admin/packProperties/Index.vue"),
          meta: { title: "router.packProperties", has_ribbon: true },
        },
        {
          path: "/pack-properties/create",
          name: "pack-properties.create",
          component: () =>
            import("@/view/pages/admin/packProperties/Create.vue"),
          meta: { title: "router.createPackProperty", has_ribbon: true },
        },
        {
          path: "/pack-properties/:id",
          name: "pack-properties.edit",
          component: () => import("@/view/pages/admin/packProperties/Edit.vue"),
          meta: { title: "router.editPackProperty", has_ribbon: true },
          props: true,
        },
        {
          path: "/panels",
          name: "panels.index",
          component: () => import("@/view/pages/admin/panels/Index.vue"),
          meta: {
            title: "router.panels",
            permission: "pack_access",
            has_ribbon: true,
          },
        },
        {
          path: "/panels/create",
          name: "panels.create",
          component: () => import("@/view/pages/admin/panels/Create.vue"),
          meta: {
            title: "router.createPanel",
            permission: "pack_create",
            has_ribbon: true,
          },
        },
        {
          path: "/panels/:id",
          name: "panels.edit",
          component: () => import("@/view/pages/admin/panels/Edit.vue"),
          meta: {
            title: "router.editPanel",
            permission: "pack_edit",
            has_ribbon: true,
          },
          props: true,
        },
        {
          path: "/admin/transferRequests",
          name: "transferRequests.index",
          component: () =>
            import("@/view/pages/admin/transferRequest/Index.vue"),
          meta: {
            title: "router.transferRequests",
            permission: "transfer_request_access",
            has_ribbon: true,
          },
        },
        {
          path: "/admin/transferRequests/:id",
          name: "transferRequests.edit",
          component: () =>
            import("@/view/pages/admin/transferRequest/Index.vue"),
          meta: {
            title: "router.editTransferRequest",
            permission: "transfer_request_edit",
            has_ribbon: true,
          },
        },
        {
          path: "/tariff",
          name: "tariff.index",
          component: () => import("@/view/pages/admin/tariff/Index.vue"),
          meta: { title: "router.tariffs", has_ribbon: true },
        },
        {
          path: "/tariff/create",
          name: "tariff.create",
          component: () => import("@/view/pages/admin/tariff/Create.vue"),
          meta: { title: "router.createTariff", has_ribbon: true },
        },
        {
          path: "/tariff/:id",
          name: "tariff.edit",
          component: () => import("@/view/pages/admin/tariff/Edit.vue"),
          meta: { title: "router.editTariff", has_ribbon: true },
          props: true,
        },
        {
          path: "user/confirmed",
          name: "user.confirmed",
          component: () => import("@/view/pages/admin/confirm/Index.vue"),
          meta: {
            title: "router.requests",
            permission: "user_access",
            has_ribbon: true,
          },
        },
        {
          path: "user/confirmed/:id",
          name: "user.confirmed.show",
          component: () => import("@/view/pages/admin/confirm/Show.vue"),
          meta: {
            title: "router.viewUser",
            permission: "user_show",
            has_ribbon: true,
          },
          props: true,
        },
        {
          path: "admin/transactions",
          name: "transactions",
          component: () => import("@/view/pages/admin/transactions/Index.vue"),
          meta: {
            title: "router.manageTransactions",
            permission: "transaction_access",
            has_ribbon: true,
          },
        },
        {
          path: "admin/transactions/:id",
          name: "admin.transactions.show",
          component: () =>
            import("@/view/pages/admin/transactions/actions/Information.vue"),
          meta: {
            title: "router.viewTransaction",
            permission: "transaction_show",
            has_ribbon: true,
          },
          props: true,
        },
        {
          path: "admin/configs",
          name: "configs",
          component: () => import("@/view/pages/admin/config/Index.vue"),
          meta: {
            title: "router.manageConfigs",
            permission: "config_access",
            has_ribbon: true,
          },
        },
        {
          path: "admin/configs/rbLand",
          name: "configs.rbLand",
          component: () => import("@/view/pages/admin/config/rbConfig.vue"),
          meta: {
            title: "router.rbLandConfigs",
            permission: "config_access",
            has_ribbon: true,
          },
        },
        {
          path: "admin/configs/:id",
          name: "admin.configs.show",
          component: () => import("@/view/pages/admin/config/Edit.vue"),
          meta: {
            title: "router.editConfig",
            permission: "config_show",
            has_ribbon: true,
          },
          props: true,
        },
        {
          path: "users",
          name: "users",
          component: () => import("@/view/pages/admin/users/Index.vue"),
          meta: {
            title: "router.manageUsers",
            permission: "user_access",
            has_ribbon: true,
          },
        },
        {
          path: "users/:id",
          name: "users.show",
          component: () => import("@/view/pages/admin/users/Show.vue"),
          meta: {
            title: "router.viewUser",
            permission: "user_show",
            has_ribbon: true,
          },
          props: true,
        },
        {
          path: "/category",
          name: "category.index",
          component: () => import("@/view/pages/categories/Index.vue"),
          meta: {
            title: "router.categories",
            permission: "category_access",
            has_ribbon: true,
          },
        },
        {
          path: "/category/create",
          name: "category.create",
          component: () => import("@/view/pages/categories/Create.vue"),
          meta: {
            title: "router.createCategory",
            permission: "category_create",
            has_ribbon: true,
          },
        },
        {
          path: "/category/edit/:id",
          name: "category.edit",
          component: () => import("@/view/pages/categories/Edit.vue"),
          meta: {
            title: "router.editCategory",
            permission: "category_edit",
            has_ribbon: true,
          },
          props: true,
        },
        {
          path: "/content",
          name: "content.index",
          component: () => import("@/view/pages/content/Index.vue"),
          meta: {
            title: "router.content",
            permission: "content_access",
            has_ribbon: true,
          },
        },
        {
          path: "/content/create",
          name: "content.create",
          component: () => import("@/view/pages/content/Create.vue"),
          meta: {
            title: "router.createContent",
            permission: "content_create",
            has_ribbon: true,
          },
        },
        {
          path: "/content/edit/:id",
          name: "content.edit",
          component: () => import("@/view/pages/content/Edit.vue"),
          meta: {
            title: "router.editContent",
            permission: "content_edit",
            has_ribbon: true,
          },
          props: true,
        },
        {
          path: "/admin/user-guide",
          name: "admin.user.guide.store",
          component: () =>
            import("@/view/pages/admin/userGuide/userGuideStore.vue"),
          meta: {
            title: "router.addUserGuide",
            permission: "content_access",
            has_ribbon: true,
          },
        },
        {
          path: "/admin/testhelpinfo",
          name: "admin.testhelpinfo",
          component: () =>
            import("@/view/pages/admin/userGuide/test_help_info.vue"),
          meta: { title: "router.addUserGuide", has_ribbon: true },
        },
        {
          path: "/admin/user-guide/:id",
          name: "admin.user.guide.store.edit",
          component: () =>
            import("@/view/pages/admin/userGuide/editUserGuide.vue"),
          meta: {
            title: "router.editUserGuide",
            permission: "content_access",
            has_ribbon: true,
          },
        },
        {
          path: "/role",
          name: "roles.index",
          component: () => import("@/view/pages/Roles/Index.vue"),
          meta: {
            title: "router.roles",
            permission: "role_access",
            has_ribbon: true,
          },
        },
        {
          path: "/role/edit/:id",
          name: "role.edit",
          component: () => import("@/view/pages/Roles/Edit.vue"),
          meta: {
            title: "router.editRole",
            permission: "role_edit",
            has_ribbon: true,
          },
          props: true,
        },
        {
          path: "/role/store",
          name: "roles.store",
          component: () => import("@/view/pages/Roles/CreateRole.vue"),
          meta: {
            title: "router.createRole",
            permission: "role_create",
            has_ribbon: true,
          },
        },
        {
          path: "/permission/create",
          name: "permission.create",
          component: () => import("@/view/pages/permission/Create.vue"),
          meta: { title: "router.createPermission", has_ribbon: true },
        },
        {
          path: "/permission/edit/:id",
          name: "permission.edit",
          component: () => import("@/view/pages/permission/Edit.vue"),
          meta: {
            title: "router.permissionTitle",
            permission: "permission_edit",
            has_ribbon: true,
          },
          props: true,
        },
        {
          path: "/permission/show/:id",
          name: "permission.show",
          component: () => import("@/view/pages/permission/Show.vue"),
          meta: {
            title: "router.permissionTitle",
            permission: "permission_show",
            has_ribbon: true,
          },
        },
        {
          path: "/permission/index",
          name: "permission.index",
          component: () => import("@/view/pages/permission/Index.vue"),
          meta: {
            title: "router.permissionTitle",
            permission: "paymentGateway_access",
            has_ribbon: true,
          },
        },
        {
          path: "/payments",
          name: "payments.index",
          component: () => import("@/view/pages/admin/payment/Index.vue"),
          meta: {
            title: "router.paymentGateways",
            permission: "paymentGateway_access",
            has_ribbon: true,
          },
        },
        {
          path: "/payment/:id",
          name: "payment.edit",
          component: () => import("@/view/pages/admin/payment/Edit.vue"),
          meta: {
            title: "router.editPaymentGateway",
            permission: "paymentGateway_edit",
            has_ribbon: true,
          },
          props: true,
        },
        {
          path: "admin/campaign",
          name: "admin.campaign",
          component: () => import("@/view/pages/admin/campaign/Index.vue"),
          meta: {
            title: "router.campaigns",
            permission: "user_access",
            has_ribbon: true,
          },
        },
        {
          path: "admin/campaign/create",
          name: "admin.campaign.create",
          component: () => import("@/view/pages/admin/campaign/Create.vue"),
          meta: {
            title: "router.createCampaign",
            permission: "user_create",
            has_ribbon: true,
          },
        },
        {
          path: "admin/campaign/:id",
          name: "admin.campaign.edit",
          component: () => import("@/view/pages/admin/campaign/Edit.vue"),
          meta: {
            title: "router.editCampaign",
            permission: "user_edit",
            has_ribbon: true,
          },
          props: true,
        },
        {
          path: "admin/customers",
          name: "admin.customers",
          component: () => import("@/view/pages/admin/customers/Index.vue"),
          meta: {
            title: "router.adminCustomers",
            permission: "customers_index",
            has_ribbon: true,
          },
        },
        {
          path: "admin/customers/create",
          name: "admin.customers.create",
          component: () => import("@/view/pages/admin/customers/Create.vue"),
          meta: {
            title: "router.createCustomer",
            permission: "customers_create",
            has_ribbon: true,
          },
        },
        {
          path: "admin/customer/:id",
          name: "admin.customers.edit",
          component: () => import("@/view/pages/admin/customers/Edit.vue"),
          meta: {
            title: "router.editCustomerInfo",
            permission: "customers_edit",
            has_ribbon: true,
          },
          props: true,
        },
        {
          path: "admin/owner-customers/:user_id",
          name: "admin.customers.owner",
          component: () =>
            import("@/view/pages/admin/customers/CustomerOwner.vue"),
          meta: {
            title: "router.referrerCustomers",
            permission: "show_owner_btn_customers",
            has_ribbon: true,
          },
          props: true,
        },
        {
          path: "admin/customer-history/:phone",
          name: "admin.customers.history",
          component: () =>
            import("@/view/pages/admin/customers/CustomerHistory.vue"),
          meta: {
            title: "router.customerHistory",
            permission: "customers_history",
            has_ribbon: true,
          },
          props: true,
        },
        {
          path: "/custom-plugins",
          name: "plugins",
          component: () => import("@/view/pages/plugins/Plugins.vue"),
          children: [
            {
              path: "/cropper",
              name: "cropper",
              component: () => import("@/view/pages/plugins/Cropper.vue"),
            },
          ],
        },
        {
          path: "/profile",
          name: "profile",
          meta: { title: "router.userProfile", has_ribbon: true },
          component: () => import("@/view/pages/profile/newProfile"),
          children: [
            {
              path: "my-profile",
              redirect: "/profile",
            },
            {
              path: "old-my-profile",
              name: "myProfile",
              component: () => import("@/view/pages/profile/MyProfile.vue"),
              meta: { title: "router.editProfile", has_ribbon: true },
            },
            {
              path: "invite-friends",
              name: "profile.invitation",
              meta: { title: "router.inviteFriends", has_ribbon: true },
              component: () =>
                import("@/view/pages/profile/profile-comp-1/Widget3.vue"),
              beforeEnter: (to, from, next) => {
                window.scrollTo({ behavior: "smooth", top: 200, left: 0 });
                next();
              },
            },
            {
              path: "info",
              name: "profile.info",
              meta: { title: "router.personalInfo", has_ribbon: true },
              component: () =>
                import("@/view/pages/profile/userInfo/userInfo.vue"),
              beforeEnter: (to, from, next) => {
                window.scrollTo({ behavior: "smooth", top: 200, left: 0 });
                next();
              },
            },
            {
              path: "edit-personal",
              name: "profile.edit",
              meta: { title: "router.editPersonalInfo", has_ribbon: true },
              component: () =>
                import("./view/pages/profile/profile-comp/EmailSettings"),
              beforeEnter: (to, from, next) => {
                window.scrollTo({ behavior: "smooth", top: 200, left: 0 });
                next();
              },
            },
            {
              path: "change-password",
              name: "profile.changePass",
              meta: { title: "router.changePassword", has_ribbon: true },
              component: () =>
                import("./view/pages/profile/profile-comp/ChangePassword"),
              beforeEnter: (to, from, next) => {
                window.scrollTo({ behavior: "smooth", top: 200, left: 0 });
                next();
              },
            },
          ],
        },
        {
          path: "admin/wallet",
          name: "admin.wallet.index",
          component: () => import("@/view/pages/admin/newWallet/Index.vue"),
          meta: { title: "router.newWallet", has_ribbon: true },
        },
        {
          path: "admin/products",
          name: "admin.products.index",
          component: () =>
            import("@/view/pages/admin/newWallet/products/Index.vue"),
          meta: { title: "router.newWallet", has_ribbon: true },
        },
      ],
    },
    // ERRORS
    {
      path: "/custom-error",
      name: "error",
      component: () => import("@/view/pages/error/Error.vue"),
      children: [
        {
          path: "/error-1",
          name: "error-1",
          component: () => import("@/view/pages/error/Error-1.vue"),
        },
      ],
    },
    // LOGIN REGISTER
    {
      path: "/login",
      name: "login",
      component: () => import("@/view/pages/auth/login"),
      children: [
        {
          name: "register",
          path: "/register",
          component: () => import("@/view/pages/auth/login_pages/Login-1"),
        },
      ],
    },
    // 404
    {
      path: "*",
      redirect: "/404",
    },
    {
      path: "/404",
      name: "404",
      component: () => import("@/view/pages/error/Error-1.vue"),
    },
  ],
});
router.beforeEach((to, from, next) => {
  const title = to.meta.title
    ? i18n.t(to.meta.title)
    : i18n.t("MENUS.AD_TERMINAL_SYSTEM");
  document.title = title;
  next();
});
export default router;
